import React from 'react';
import { Typography, Box, Container } from '@mui/material';
import Image from 'next/image';
import IconCard from '../../../../../commons/components/ui/Cards/IconCard/IconCard';
import { highlightsContent } from '../../../../../commons/Constants/HighlightSection';
import styles from './ProductHighlights.module.scss';
import { UP_CURVED, DOWN_CURVED } from '../../../../../src/assets/images/icons';

export default function ProductHighlights({ id, productType }) {
  const productData = highlightsContent[productType];
  if (!productData) return null;

  const { icon, title, description, highlights } = productData;

  return (
    <div className={styles.highlightSectionWrapper} id={id}>
      <div className={styles.highlightSection}>
        <Container maxWidth="xl" className={styles.container}>
          <div className={styles.highlightIcon}>
            <Image
              src={icon}
              alt="Immune leaf icon"
              width={32}
              height={32}
              placeholder="blur"
              blurDataURL={icon}
            />
          </div>
          <div className={styles.titleContainer}>
            <Typography
              variant="h2"
              color="primary.main"
              className={styles.sectionTitle}
              dangerouslySetInnerHTML={{ __html: title }}
              sx={{ textWrap: 'pretty' }}
            />
            <Typography
              variant="p1-book"
              color="primary.black"
              className={styles.sectionSubtitle}
            >
              {description}
            </Typography>
          </div>

          {/* Highlight cards with dotted connectors */}
          <Box className={styles.highlightCardRow}>
            {highlights.map((item, index) => {
              const isLast = index === highlights.length - 1;
              const isUp = index % 2 === 0;

              const curveType = !isLast ? (
                isUp ? (
                  <UP_CURVED />
                ) : (
                  <DOWN_CURVED />
                )
              ) : null;
              const curveClass = !isLast
                ? isUp
                  ? styles.upCurve
                  : styles.downCurve
                : '';

              return (
                <IconCard
                  key={index}
                  icon={item.icon}
                  title={item.title}
                  description={item.description}
                  curveType={curveType}
                  curveClass={curveClass}
                />
              );
            })}
          </Box>
        </Container>
      </div>
    </div>
  );
}
